import seasonText from '../json/seasonText.json'
import round from '../json/roundCode.json'
import race from '../json/raceEventCode.json'
import raceDetail from '../json/raceEventDetailCode.json'
import raceDifference from '../json/raceDifferenceCode.json'

const code = {
  seasonText,
  round,
  race,
  raceDetail,
  raceDifference
}

export function getCode (key, id) {
  const result = code[key][id];
  return result ? result : {"name": ''};
}
